document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("asStoryBtnOpen");
  const headerStoryOpenBtns = document.querySelectorAll(".as-header-story");
  const closeBtn = document.getElementById("asStoryBtnClose");
  const popup = document.getElementById("storyPopup");

  const playPauseBtn = document.getElementById("playPauseBtn");
  const playIcon = playPauseBtn?.querySelector(".play-btn");
  const pauseIcon = playPauseBtn?.querySelector(".pause-btn");

  const prevBtn = document.querySelector(".story-prev-btn");
  const nextBtn = document.querySelector(".story-next-btn");

  const swiperEl = document.querySelector(".storySwiper");

  let swiper;
  let progressBars = [];
  let activeIndex = 0;
  let isPlaying = true;
  let duration = 5000;
  let timer;

  // NOTE: Mobile menu open/close scroll-lock is handled exclusively in as-header.liquid
  // to avoid double-locking on iOS Safari. Do NOT add menu handlers here.

  //story popup start
  function createProgressBars() {
    const container = document.querySelector(".story-progress-container");
    container.innerHTML = "";
    progressBars = [];

    document.querySelectorAll(".storySwiper .swiper-slide").forEach(() => {
      const bar = document.createElement("div");
      bar.classList.add("story-progress-bar");

      const fill = document.createElement("div");
      fill.classList.add("story-progress-fill");

      bar.appendChild(fill);
      container.appendChild(bar);
      progressBars.push(fill);
    });

    progressBars.forEach((bar) => {
      bar.style.width = "0%";
      bar.style.transition = "none";
    });
  }

  function startProgress() {
    clearTimeout(timer);

    progressBars.forEach((bar, index) => {
      if (index < activeIndex) {
        bar.style.transition = "none";
        bar.style.width = "100%";
      }
      if (index > activeIndex) {
        bar.style.transition = "none";
        bar.style.width = "0%";
      }
    });

    const bar = progressBars[activeIndex];
    bar.style.transition = `width ${duration}ms linear`;
    bar.style.width = "100%";

    timer = setTimeout(() => {
      swiper.slideNext();
    }, duration);
  }

  function pauseStory() {
    isPlaying = false;
    clearTimeout(timer);

    const bar = progressBars[activeIndex];
    const currentWidth = bar.getBoundingClientRect().width;
    const fullWidth = bar.parentElement.getBoundingClientRect().width;
    const progress = (currentWidth / fullWidth) * 100;

    bar.style.transition = "none";
    bar.style.width = progress + "%";

    playIcon.style.display = "block";
    pauseIcon.style.display = "none";
  }

  function playStory() {
    isPlaying = true;

    const bar = progressBars[activeIndex];
    const currentWidth = bar.getBoundingClientRect().width;
    const fullWidth = bar.parentElement.getBoundingClientRect().width;
    const remaining = duration * (1 - currentWidth / fullWidth);

    bar.style.transition = `width ${remaining}ms linear`;
    bar.style.width = "100%";

    timer = setTimeout(() => {
      swiper.slideNext();
    }, remaining);

    playIcon.style.display = "none";
    pauseIcon.style.display = "block";
  }

  function openStoryPopup() {
    if (!popup) return;

    popup.style.display = "flex";
    popup.classList.add("active");
    // Lock scroll so the page behind the story popup cannot scroll on iOS Safari
    window.__asLockScroll && window.__asLockScroll();

    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }

    createProgressBars();

    swiper = new Swiper(swiperEl, {
      allowTouchMove: false,
      speed: 300,
      on: {
        slideChange: () => {
          activeIndex = swiper.activeIndex;
          if (isPlaying) startProgress();
        },
      },
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        startProgress();
      });
    });
  }

  if (playPauseBtn) {
    playPauseBtn.addEventListener("click", () => {
      if (isPlaying) pauseStory();
      else playStory();
    });
  }

  if (openBtn) {
    openBtn.addEventListener("click", function (event) {
      event.preventDefault();
      openStoryPopup();
    });
  }

  if (headerStoryOpenBtns.length) {
    headerStoryOpenBtns.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        openStoryPopup();
      });
    });
  }
  document.addEventListener("asStoryOpen", function () {
    // Re-use whatever function your slider already calls on open.
    // Replace `openStoryPopup()` with your actual open function name if different.
    if (typeof openStoryPopup === "function") {
      openStoryPopup();
    } else {
      // Generic fallback: show popup + reset/start the swiper & progress
      var popup = document.getElementById("storyPopup");
      if (popup) {
        popup.classList.add("active");
        popup.style.display = "flex";
        // If your swiper is stored globally, restart it
        if (typeof storySwiper !== "undefined" && storySwiper) {
          storySwiper.slideTo(0);
        }
      }
    }
  });

  closeBtn.addEventListener("click", () => {
    popup.style.display = "none";
    popup.classList.remove("active");
    // Restore body scroll on iOS Safari
    window.__asUnlockScroll && window.__asUnlockScroll();
    clearTimeout(timer);
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  });

  nextBtn.addEventListener("click", () => swiper.slideNext());
  prevBtn.addEventListener("click", () => swiper.slidePrev());
});

//search popup close
